import { Card, Divider, Flex } from "@chakra-ui/react";
import { IPartnerInfo } from "@iloq/shared/IPartnerInfo";
import { ReactNode } from "react";
import { ContactPersonPartner } from "./contact-person-partner";
import { PartnerInfoHeader } from "./partner-info-header";
import { PartnerNps } from "./partner-stats/partner-nps";
import { PartnerOrders } from "./partner-stats/partner-orders";
import { PartnerProjects } from "./partner-stats/partner-projects";
import { PartnerReturns } from "./partner-stats/partner-returns";
import { PartnerSubscriptions } from "./partner-stats/partner-subscriptions";

export function PartnerProgramInfo({
  partnerInfo,
  hasPartnerProgramRights,
  hasCreateOpportunityRights,
}: {
  partnerInfo: IPartnerInfo;
  hasPartnerProgramRights: boolean;
  hasCreateOpportunityRights: boolean;
}): ReactNode {
  const tier = partnerInfo.marketingTier!;

  return (
    <Card
      alignSelf="stretch"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      borderRadius="16px"
      marginX="3xl"
      marginBottom="-30px"
    >
      <PartnerInfoHeader tier={tier} partnerName={partnerInfo.partnerName} />

      <Flex
        flexDir={{ base: "column", lg: "row" }}
        columnGap="auto"
        rowGap={{ base: "4", lg: "8" }}
        padding={{ base: "lg", lg: "2xl" }}
        width="100%"
        alignItems="stretch"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <PartnerNps />

        <Divider
          orientation="vertical"
          borderColor="brand.blueLightest"
          alignSelf="stretch"
          height="auto"
        />

        <Flex
          flexDir="row"
          justifyContent="space-between"
          columnGap="auto"
          rowGap="4"
          flexWrap={{ base: "wrap", lg: "nowrap" }}
        >
          <PartnerOrders />
          <PartnerReturns />
          <PartnerProjects
            isDisabled={!hasPartnerProgramRights}
            createLinkDisabled={!hasCreateOpportunityRights}
          />
          <PartnerSubscriptions />
        </Flex>

        <Divider
          orientation="vertical"
          borderColor="brand.blueLightest"
          alignSelf="stretch"
          height="auto"
        />

        <ContactPersonPartner />
      </Flex>
    </Card>
  );
}
